import React, {useEffect, useRef, useState} from "react";
import { AutoComplete } from 'primereact/autocomplete';
import fetch from '../../../config/service';
import config from "../../../config/config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAsterisk } from "@fortawesome/free-solid-svg-icons";

const DoAutoCompleteField = (props) => {
    const [filteredSuggestions, setFilteredSuggestions] = useState([]);
    const [isValidate,setIsValidate] = useState(false);
    const [noData,setNoData] = useState(false);
    const [errorMessage,setErrorMessage] = useState('');
    const [disable, setDisable] = props.item?.hasDependencyField ? useState(false) : useState(false); 

    let message;
    const id = props.id ? props.id : props.name;
    const label = props.label ? props.label : '';
    const name = props.name;
    const type = props.type ? props.type : 'text';
    let field = props.field;
    const placeholder = props.placeholder;
    let parentField = props.watch && props.item.hasDependencyField ? props.watch(props.item.hasDependencyField) : '';
    let previousParentRef = useRef(parentField);
    let selectedCity = props.watch ? props.watch('city') : null;
    const item = props.item ? props.item:{};
    const formType = props.formType ? props.formType : "";
    const screenName=props.screenName;
    const rowData = props.rowData ? props.rowData : {};

    useEffect(() => {
        if(props.item?.hasDependencyField){
           
            if(parentField){
                // setDisable(false);
                setErrorMessage('')
                setTimeout(() => {
                    previousParentRef.current = parentField
                }, 100);
            } else {
                // setDisable(true);
            }
            if (parentField && ((previousParentRef.current?._id !== parentField?._id) || previousParentRef.current !== parentField)) {
                props.setValue(props.field.name,'');
            }
        }
        if (screenName === "Searches") {
          if (formType === "add") {
            getCities("Hyderabad");
          }
          if (formType === "edit" && rowData?.city?.city) {
            getCities(rowData?.city?.city);
          }
        }        
        
    }, [parentField])

    // below function fetches the cities and localities for default city and locality setting in Search screen
    const getCities = (selectedCityName) =>{
        if(item?.name === 'city') {
            {fetch('GET', `localities`).then(async (response) => {
                if (response ) {
                     response.localities?.forEach((ele) => {
                       if(ele?.city=== selectedCityName ){
                        props?.onChange(item , ele.area? ele.area : []);
                        }
                     })
                 
                }
              })}            
        }
    }
    
    const onSelectRecord = (e)=> {
        setNoData(false);
        setIsValidate(false);
        setErrorMessage('');
        if (props.input) {
            const { name, onChange } = this.props.input;
            onChange(e.value);
            this.props.handleAutoCompleteData(e.value, name)
            if (e && e.value) {
                this.removeDuplicates(e.value, name);
            }
        }

    }

     const getAllSuggestions = (event, type) => {
        let url;
        setIsValidate(false);
        setNoData(false);
        setErrorMessage('');
        let filterCriteria = {
            limit: 30,
            page: 1,
            sortfield: "created",
            direction: "desc",
            criteria: []
        };

        if(props.item?.hasDependencyField){
            let value = item.hasDependencyValueType=='string' ? props.getValues(props.item.hasDependencyField) :props.getValues(props.item.hasDependencyField)?.["_id"];
            if(value){
                filterCriteria['criteria'].push({
                    "key":props.item.fieldForKey,
                    "value":value,
                    "type":"eq"
                })
            } else if (!props.selectedArea?.area || !Object.keys(props.selectedArea?.area).length) {
                setNoData(true);
                setFilteredSuggestions([]);
                setErrorMessage('Please select the ' + props.item.hasDependencyField[0].toUpperCase() +  props.item.hasDependencyField.slice(1));
                return
            }
        }

         if (event && event.query) {
             filterCriteria['criteria'].push({
                 "key": props.searchField,
                 "value": event.query,
                 "type": "regexOr"
             });
         };
         if (props?.criteria?.length > 0){
            props.criteria.forEach(item =>{
                filterCriteria['criteria'].push(item);
            })             
         }
         if (props.item?.name === 'locality') {
             let areas = typeof selectedCity === 'object' ? selectedCity.area : props.selectedArea.area;

             if (event.query) {
                 const filteredAreas = areas?.filter(obj =>
                     obj.area.toLowerCase().includes(event.query.toLowerCase())
                 );
                 setFilteredSuggestions(filteredAreas);
             } else {
                 setFilteredSuggestions(JSON.parse(JSON.stringify(areas)));
             }
         } else {
             let apiUrl = props.searchApi?.toLowerCase();
             url = `${apiUrl}?searchFrom=autoComplete&filter=${JSON.stringify(filterCriteria)}`;
             return fetch('GET', url)
                 .then((response) => {
                     if (response) {
                         let dropdownData = [];
                         const resKey = item?.responseKey || apiUrl;
                         if (response[resKey] && response[resKey].length && response[resKey].length > 0) {
                             dropdownData = response[resKey];
                         }
                         if (dropdownData && dropdownData.length == 0) {
                             setFilteredSuggestions([]);
                             setNoData(true);
                         } else {
                             setSuggestions(dropdownData);
                         }
                     }
                 }).catch((err) => {
                     return err;
                 });
         }
    }

// Function to set the current slot time in Appointment Dropdown while editing

    const setCurrentTimeSlotInDropDownData=(dropdownData)=>{
        let currentSlotObj = dropdownData[0]? JSON.parse(JSON.stringify(dropdownData[0])):{};
        let timeArray = rowData?.time?.slotTime?.toString().split("-");
        currentSlotObj.fromTime = timeArray[0].trim();
        currentSlotObj.toTime = timeArray[1].trim();
        currentSlotObj.slotTime = rowData?.time?.slotTime;
        currentSlotObj._id = rowData?.time?._id;
        if (rowData.dateString === props.appointmentDateString) {
          dropdownData.unshift(currentSlotObj);
        }    
}
    
    const setSuggestions = async (dropdownData) => {
        if (props.input && props.input.value) {
            if (props.input.value.length > 0) {
                let values = props.input.value;
                if (Array.isArray(values)) {
                    values.forEach(element => {
                        let field = '_id';
                        dropdownData = dropdownData.filter((item) => item[field] !== element[field]);
                    });
                }
            }
        }
        if(props.screenName==="Appointments"&&formType==="edit"){
              setCurrentTimeSlotInDropDownData(dropdownData)
        }
        setFilteredSuggestions(dropdownData);
    }

    if(props.fieldState.invalid){
        message = props.errors[props.name]?.message;
        if(props.errors[props.name]?.message.includes("must be a `object` type")) {
            message = "Select a valid option";
        }
    }

    let markRequired = () => {
        return (
          <FontAwesomeIcon
            color='red'
            icon={faAsterisk}
            style={{ width: '7px',marginBottom:"5px",marginLeft:"2px" }}
          />
        );
    };

    let onSelect = (e) => {

        if(props.screenName==="Searches"&& item.name === 'city'){
            getCities(e.value?.city? e.value.city : e.value);
            return
        }
       
        if (props?.getValues && !props?.getValues(props.item?.name)) {
            props.setValue(props.item?.name, e.value)
        }
    }

    return (
        <div className="flex flex-column">

            <div className="flex align-center"> {/* Added a wrapper div with flex class */}
                <label htmlFor={id} className="text-capitalize">{label}</label>
                {props.markReq && props.markReq === true && markRequired()}
            </div>
            <AutoComplete
                inputId={field.name}
                value={field.value}
                onChange={field.onChange}
                // inputRef={field.ref}
                panelStyle={{ width: '100px' }}
                style={props.style? props.style : {}}
                disabled={disable}
                suggestions={filteredSuggestions}
                completeMethod={getAllSuggestions}
                placeholder={field.value == undefined || field.value.length == 0 ? placeholder : ''}
                field={props.searchField}
                dropdown={true}
                onSelect={onSelect}
                multiple={props.multiple}
                selectionLimit={props.selectionLimit ? props.selectionLimit : config.selectionLimit}
                showEmptyMessage={true}
            />

            <small className="text-danger mt-1">{props.fieldState.invalid ? message ? message : props.errors[props.name]?.message : ''}</small>
            {errorMessage && <small className="text-danger" style={props.style ? props.style : {}}>{errorMessage}</small>}
            {/* {noData && !props.fieldState.invalid && <small className="text-danger" style={props.style ? props.style : {}}>{'No Data Found'}</small>} */}
        </div>
    )

}

export default DoAutoCompleteField;